export const getPackageVersion = () => {return "6.7.0";}; // Avoid manual modification.